import * as React from 'react';
import Modal from 'react-modal';

import Button from 'components/ButtonDeprecated';
// @ts-ignore
import FreeClassLimitsLearnMoreDialog from 'groups/components/FreeClassLimitsLearnMoreDialog';
import GroupAvatar from 'groups/components/GroupAvatar';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithIcon from 'components/TextWithIcon';
// @ts-ignore
import GroupStore from 'groups/stores/GroupStore';
import Group from 'entities/Group';

import { ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity } from 'chat_v2/components/SplitComposer/queries/__generated__/ComposerRecipients';

type Props = {
  entity: ComposerRecipients_composerRecipients_recipients_ComposerRecipientListEntity,
};

type State = {
  classLimitsDialogIsOpen: boolean;
};

class LimitedGroupRecipientItem extends React.Component<Props, State> {
  state = {
    classLimitsDialogIsOpen: false,
  };

  openClassLimitsDialog = () => {
    this.setState({ classLimitsDialogIsOpen: true });
  };

  closeClassLimitsDialog = () => {
    this.setState({ classLimitsDialogIsOpen: false });
  };

  render() {
    const { entity } = this.props;
    const { content, recipient } = entity;
    const groupAvatarProp = {
      groupAvatar: { svg_url: content.avatar.__typename === 'RemoteImageAvatar' ? content.avatar.imageUrl : '' },
    };
    const group = GroupStore.selectGroups((g: Group) => g.getUuid() === recipient.uuid).first;

    return (
      <React.Fragment>
        <Modal isOpen={this.state.classLimitsDialogIsOpen}>
          <FreeClassLimitsLearnMoreDialog
            peopleListUrl={group ?? `/classes/${group.name}/people`}
            onRequestHide={this.closeClassLimitsDialog}
            uiContext="composer_recipient"
          />
        </Modal>
        <li className="RecipientItem" onClick={this.openClassLimitsDialog}>
          <MediaObject figure="right" center>
            <MediaObject gutter="small" center>
              <GroupAvatar group={groupAvatarProp} size="small" />
              <div>
                <Row size="xxsmall">
                  <Text size="small" element="div" truncate>
                    {content.title}
                  </Text>
                </Row>
                <TextWithIcon color="apple" icon="explanation-circle" iconColor="apple">
                  Announcements are unavailable
                </TextWithIcon>
              </div>
            </MediaObject>
            <Button level="secondary" size="xsmall" data-test="limited-send-functionality-button">
              Learn more
            </Button>
          </MediaObject>
        </li>
      </React.Fragment>
    );
  }
}

export default LimitedGroupRecipientItem;
